module.exports = __webpack_public_path__ + "static/images/drop-off.3aL4V99.svg";